export default "__VITE_ASSET__FgjL8UA7__"